import React from 'react';

interface SEOProps {
    title: string;
    slug: string;
    description: string;
    baseUrl: string;
}

const GooglePreview: React.FC<SEOProps> = ({ title, slug, description, baseUrl }) => {
    // SEO Scoring Logic
    const titleScore = title.length >= 50 && title.length <= 60 ? '#22c55e' : '#f97316'; // green-500 : orange-500
    const descScore = description.length >= 120 && description.length <= 160 ? '#22c55e' : '#f97316';

    const displayBaseUrl = baseUrl.replace(/\/$/, '');

    return (
        <div className="p-8 border border-gray-100 rounded-[2rem] bg-white shadow-sm max-w-2xl font-sans">
            <h3 className="text-[10px] font-black text-gray-400 uppercase tracking-widest mb-6">Google Search Result Preview</h3>

            {/* Search Result Layout */}
            <div className="flex flex-col gap-1">
                <cite className="text-sm text-[#202124] not-italic truncate">
                    {displayBaseUrl}/{slug}
                </cite>
                <h2 className="text-xl text-[#1a0dab] hover:underline cursor-pointer font-medium leading-tight">
                    {title || "Please enter a title..."}
                </h2>
                <p className="text-sm text-[#4d5156] line-clamp-2 leading-normal">
                    {description || "Provide a meta description to see how your page will appear in search results..."}
                </p>
            </div>

            {/* Score Indicators */}
            <div className="mt-8 flex gap-6 border-t border-gray-50 pt-6 text-[10px] font-black uppercase tracking-widest">
                <div className="flex items-center gap-2">
                    <span className="text-gray-400">Title:</span>
                    <span style={{ color: titleScore }}>{title.length} chars</span>
                    <span className="text-gray-300 font-normal">(Target 50-60)</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className="text-gray-400">Description:</span>
                    <span style={{ color: descScore }}>{description.length} chars</span>
                    <span className="text-gray-300 font-normal">(Target 120-160)</span>
                </div>
            </div>
        </div>
    );
};

export default GooglePreview;
